export default __webpack_public_path__ + "static/touchfree-kiosk-feedback-collector-qualitative-d04ec97159843b941ed70d443bba9104.jpg";